<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';

@Component
export default class InfraCompetencyCard extends Vue {
  @Prop({ required: true }) private icon!: string;
  @Prop({ required: true }) private title!: string;
  @Prop({ required: true }) private description!: string;
}
</script>

<template>
  <div class="comp-item ln-glass">
    <span :class="['mdi', icon]"></span>
    <div>
      <strong>{{ title }}</strong>
      <p v-html="description"></p>
    </div>
  </div>
</template>

<style scoped>
.comp-item {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  padding: 1.5rem;
  border-radius: var(--ln-radius-md);
  transition: transform var(--ln-transition-normal) var(--ln-ease-smooth);
}

.comp-item:hover {
  transform: translateY(-5px);
}

.comp-item span.mdi {
  font-size: 2rem;
  color: var(--ln-teal-deep);
  background: var(--ln-glass-surface);
  padding: 0.8rem;
  border-radius: 1rem;
}

.comp-item strong {
  display: block;
  font-size: 1.1rem;
  margin-bottom: 0.3rem;
  color: var(--ln-text-primary);
}

.comp-item p {
  font-size: 0.9rem;
  color: var(--ln-text-secondary);
  margin: 0;
}
</style>
